import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { makeStyles, createStyles, TextField, InputAdornment } from '@material-ui/core';
import Icon from '../Icon';
var placeholderStyles = {
  fontStyle: 'italic',
  fontSize: '14px'
};
var useStyles = makeStyles(function (theme) {
  return createStyles({
    searchWrapper: {
      padding: "".concat(theme.spacing(1.5), "px 0"),
      display: 'flex',
      alignItems: 'center'
    },
    // Styling input placeholders: https://stackoverflow.com/a/27644339
    searchInput: {
      '&::placeholder': placeholderStyles,
      '&::-webkit-input-placeholder': placeholderStyles,
      '&:-moz-placeholder': placeholderStyles,
      '&::-moz-placeholder': placeholderStyles,
      '&:-ms-input-placeholder': placeholderStyles
    }
  });
});
export var SearchBar = function SearchBar(_ref) {
  var e2e = _ref.e2e,
      search = _ref.search,
      searchPlaceholder = _ref.searchPlaceholder,
      onSearch = _ref.onSearch;
  var classes = useStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  return /*#__PURE__*/React.createElement(TextField, _extends({}, e2e && {
    'data-e2e': "".concat(e2e, "-table-search")
  }, {
    className: classes.searchWrapper,
    type: "text",
    variant: "standard",
    value: search,
    placeholder: searchPlaceholder,
    onChange: onSearch,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    fullWidth: true,
    style: {
      fontSize: '14px'
    },
    inputProps: {
      className: classes.searchInput
    },
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(Icon, {
        color: focused ? 'primary' : 'action',
        body: "search",
        __addMargin: true
      }))
    }
  }));
};

try {
  SearchBar.__docgenInfo = {
    description: '',
    displayName: 'SearchBar',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      search: {
        defaultValue: null,
        description: '',
        name: 'search',
        required: true,
        type: {
          name: 'string'
        }
      },
      searchPlaceholder: {
        defaultValue: null,
        description: '',
        name: 'searchPlaceholder',
        required: false,
        type: {
          name: 'string'
        }
      },
      onSearch: {
        defaultValue: null,
        description: '',
        name: 'onSearch',
        required: true,
        type: {
          name: '(event: ChangeEvent<HTMLInputElement>) => void'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=SearchBar.js.map